import { useEffect } from "react";

import { useFeedbackTool } from "@/features/request/feedback-tool/feedbackTool/hooks/useFeedbackTool.tsx";
import { useGetStories } from "@/features/request/feedback-tool/feedbackTool/hooks/useGetStories.tsx";
import {
  Form,
  Image,
  Points,
} from "@/features/request/feedback-tool/feedbackTool/image/components";
import { coordinateConvert } from "@/features/request/feedback-tool/feedbackTool/utils/coodinateConvert.ts";

export default function FeedBackImage() {
  const { img, imgRef, setFeedBack, size } = useFeedbackTool();
  const { data } = useGetStories({ parentId: img.id });

  useEffect(() => {
    if (!data) {
      setFeedBack(null);

      return;
    }

    setFeedBack(() =>
      data.length > 0
        ? data?.map((feedback, index) => ({
            attachments: feedback?.attachments
              ? feedback?.attachments.map((att) => ({
                  attachmentId: Number(att.attachmentId),
                  name: att.name,
                  storyId: Number(att.storyId),
                  url: att.url,
                }))
              : [],
            commentBatchId: feedback.commentBatchId,
            description: feedback.comment ?? "",
            format: "IMAGE",
            id: index + 1,
            imgId: img.id,
            isResolved: feedback.isResolved ?? false,
            parentId: feedback.parentId,
            storyId: feedback.id,
            updatedAt: feedback.updatedAt,
            user: {
              id: feedback.user?.id,
              name: feedback.user?.name,
            },
            x: coordinateConvert(feedback.coordinates, "y"),
            y: coordinateConvert(feedback.coordinates, "x"),
          }))
        : null,
    );
  }, [data]);

  return (
    <div
      className={`relative bg-gray-200 ${size === "MODAL" ? "max-h-150 max-w-150" : "max-h-full max-w-full"}`}
    >
      <Image imgRef={imgRef} />
      <Points imgRef={imgRef} />
      <Form imgRef={imgRef} />
    </div>
  );
}
